/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import BackBtn from './BackBtn';
import ProgressBar from './ProgressBar';
import { values, colors } from 'styles/variables';
import Menu from './Menu';
import Burger from './Burger';
import { connect } from 'react-redux';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import getStore from 'services/getStore';
import getBlockById from 'services/apiHelpers/getBlockById';
import renderBlock from 'services/apiHelpers/renderBlock';
import Image from 'components/lib/Image';
import isIE from 'services/isIE';
import {
  VisuallyHiddenLink,
  VisuallyHidden,
} from 'components/UI/VisuallyHidden';

import logo from 'assets/lizard.svg'; // lizard Logo_2019

const store = getStore();

const { lPink, lGrey0 } = colors;
const { headerHeight } = values;

interface IHeader {
  currentTopicIndex: number;
  topics: any[];
  theme: any;
}

const SkipToContent = () => {
  const [skipToContent, setSkipToContent] = useState(false);

  const a = useRef(null);

  return (
    <a
      ref={a}
      css={css`
        position: absolute;
        left: 30px;
        top: 80px;
        padding: 5px 25px;
        font-size: 12px;
        color: ${lGrey0};

        border-radius: 9999px;
        background: #fff;

        text-decoration: none;

        ${!skipToContent &&
          `border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    `}
      `}
      href={`#main`}
      onKeyUp={e => {
        if (![' ', 'Enter'].includes(e.key)) {
          return;
        }

        a.current.click();
      }}
      onFocus={() => {
        // console.log('skipToContent !!!');
        setSkipToContent(true);
      }}
      onBlur={() => {
        setSkipToContent(false);
      }}
    >
      Skip to content
    </a>
  );
};

const Header = ({ currentTopicIndex = 0, topics, theme }: IHeader) => {
  const [menu, setMenuState] = useState(false);
  const currentTopicName = topics[currentTopicIndex]
    ? topics[currentTopicIndex].props.name
    : 'unknown';
  const {
    headerBackgroundColor = '#fff',
    headerTextColor = lGrey0,
    progressBar = true,
    topicMenu = true,
  } = theme;

  const blocks = store.getState().blocks;

  // const H = Object.values(blocks).find(
  //   (b: any) => b.type === 'Header'
  // ) as any;

  const logoBlock = findByKeyVal_V2(
    (Object.values(blocks).find((b: any) => b.type === 'Header') as any).id,
    'type',
    'Logo'
  );

  if (!logoBlock.props.src) {
    logoBlock.props.src = logo;
  }

  const Logo = renderBlock(logoBlock, { Logo: Image });

  // function hideMenu() {
  const hideMenu = useCallback(() => {
    setMenuState(false);
    requestAnimationFrame(() =>
      document.removeEventListener('click', hideMenu)
    );
  }, []);

  useEffect(() => {
    // return;
    menu && document.addEventListener('click', hideMenu);

    // function hideMenu() {
    //   setMenuState(false);
    //   requestAnimationFrame(() =>
    //     document.removeEventListener('click', hideMenu)
    //   );
    // }
  }, [menu]);

  return (
    <header
      aria-label="Module header"
      css={css`
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: ${headerHeight}px;
        padding: 10px 30px;
        background: ${headerBackgroundColor};
        z-index: 1;
        // border-bottom: 1px solid #dee3f3;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        * {
          color: ${headerTextColor};
        }

        @media (max-width: 480px) {
          height: ${headerHeight - 20}px;
          padding: 0 30px;
        }
      `}
    >
      {/* all this needs to do is be visible when has focus */}
      {/* Skip to content */}
      <SkipToContent />
      {/* <VisuallyHiddenLink href={`#main`}>Skip to content</VisuallyHiddenLink> */}
      <div
        css={css`
          position: absolute;
          display: flex;
          align-items: center;
          left: 30px;
          top: 0px;
          height: ${headerHeight}px;

          @media (max-width: 480px) {
            left: 15px;
            height: ${headerHeight - 20}px;
          }
        `}
      >
        <BackBtn
          key={currentTopicIndex}
          currentTopic={topics[currentTopicIndex]}
          topics={topics}
          color={headerTextColor}
        />
        <div
          css={css`
            margin-left: 10px;

            @media (max-width: 480px) {
              display: none;
            }
          `}
        >
          <VisuallyHidden>Current Topic: </VisuallyHidden>
          {currentTopicName}
        </div>
      </div>
      <div
        css={css`
          display: flex;
          height: ${headerHeight}px;
          padding: 10px 5px;

          ${isIE &&
            `
            border: 1px solid transparent;
          `}

          img {
            max-width: 200px;
            height: 100%;
            margin: 0 35px;
          }

          @media (max-width: 480px) {
            height: ${headerHeight - 20}px;
          }
        `}
      >
        {Logo}
      </div>
      <div
        css={css`
          position: absolute;
          display: flex;
          align-items: center;
          right: 30px;
          top: 0px;
          height: ${headerHeight}px;

          @media (max-width: 480px) {
            right: 15px;
            height: ${headerHeight - 20}px;
          }
        `}
      >
        {progressBar && (
          <div
            css={css`
              margin-right: ${topicMenu ? '30' : '0'}px;

              @media (max-width: 690px) {
                display: none;
              }
            `}
          >
            <ProgressBar color={headerTextColor} />
          </div>
        )}
        {topicMenu && (
          <_>
            <Burger
              menu={menu}
              color={headerTextColor}
              onClick={() => setMenuState(true)}
            />
            <Menu
              menu={menu}
              currentTopicName={currentTopicName}
              close={() => hideMenu()}
              // color={lGrey0 || headerTextColor}
            />
          </_>
        )}
      </div>
    </header>
  );
};

export default connect(({ theme }: any) => ({ theme }))(Header);
